module.exports = __webpack_public_path__ + "static/media/google.db86b27b.svg";